module.exports = __webpack_public_path__ + "img/20.eccfa677.jpg";